export default __webpack_public_path__ + "static/media/Link to Page.917f1614.mp4";